module.exports = __webpack_public_path__ + "static/media/rotaView1.0690b356.svg";